import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';

export default class IndexRoute extends Route {
  @service store!: DS.Store;

  queryParams = {
    page: { refreshModel: true },
  };

  beforeModel() {
    return this.store.unloadAll('import');
  }

  model({ page }: { page: string }) {
    return this.store.query('import', { page });
  }
}
